const NAME = "ASSETS_DISCOUNTS_ENTRY_PER_CONCEPT";

export default NAME;
